import { Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';

interface Props {
  showTooltip?: boolean;
}

export const ExpirationColumnHeader: React.FC<Props> = ({ showTooltip = true }) => {
  const { translation } = useTranslation();

  return (
    <ColumnHeaderWithTooltip
      label={showTooltip ? translation.user_deletion : translation.expiration}
      tooltip={
        showTooltip && (
          <Stack spacing={1}>
            <Typography variant="caption">{translation.user_deletion_tooltip}</Typography>
            <Typography variant="caption">{translation.user_deletion_tooltip_entra_id}</Typography>
          </Stack>
        )
      }
    />
  );
};
